import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from '@tanstack/react-router';

import { useInterval } from '@/App.hooks';

import { useTrackingInstallion } from '@/tracking/Tracking.hooks';

import './App.css';

import { tryRefreshToken, useRefreshOnBuild } from './auth/Auth.hooks';
import { router } from './App.router';

function App() {
	useTrackingInstallion();
	// Remove comment to refresh build on logout
	useRefreshOnBuild();
	// const INTERVAL_TIME = 5 * 60 * 1000;
	const INTERVAL_TIME = 30 * 1000;
	useInterval(() => {
		tryRefreshToken('/', { minutes: 1 });
	}, INTERVAL_TIME);

	const classNames = ['App'];

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
